export const filterConfig = [{
  id: 'Nome',
  type: 'text',
  label: 'Nome',
  placeholder: 'Digite o nome do cliente'
}, {
  id: 'Cnpj',
  type: 'text',
  label: 'CNPJ',
  placeholder: 'Digite o CNPJ'
}, {
  id: 'Telefone',
  type: 'text',
  label: 'Telefone',
  placeholder: 'Digite o telefone'
}];
